const DRAFT_PREFIX = "@rascunho-";

// Após o logout, gravações de rascunho ainda agendadas (debounce/idle) ou
// disparadas no unmount dos editores não podem recriar o que acabou de ser
// apagado. Liberado de novo no próximo login.
let draftsBlocked = false;

/** Indica se rascunhos podem ser gravados no localStorage. */
export const canPersistDrafts = () => !draftsBlocked;

/** Libera a gravação de rascunhos (chamado no login). */
export const allowDraftPersistence = () => {
  draftsBlocked = false;
};

/**
 * Remove do localStorage todos os rascunhos (texto e imagens) de pacientes e
 * bloqueia novas gravações até o próximo login. Chamado no logout para que
 * dados de saúde não fiquem acessíveis a outro usuário do mesmo navegador.
 *
 * De propósito, NÃO é chamado quando a sessão expira (401 / token vencido):
 * o redirecionamento para o login recarrega a página e o rascunho é a única
 * cópia do que estava sendo digitado. As chaves incluem o id do usuário, então
 * quem logar depois no mesmo navegador não enxerga o rascunho alheio.
 */
const clearDrafts = () => {
  draftsBlocked = true;
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(DRAFT_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    // localStorage indisponível: nada a limpar.
  }
};

export default clearDrafts;
